<glxy-table-container [dataSource]="dataSource" [columns]="columns" [pageSizeOptions]="[5, 10, 20]" [fullWidth]="true">
  <span class="download-data-header">
    <glxy-table-content-header
      [showFilters]="false"
      [showSearch]="false"
      [showSort]="false"
      [showActions]="false"
    ></glxy-table-content-header>
    <button mat-stroked-button (click)="openDownloadDialog()">
      <mat-icon>cloud_download</mat-icon>
      {{ 'CONTACT_TABLE.DOWNLOAD_DIALOG.DOWNLOAD' | translate }}
    </button>
  </span>

  <table mat-table>
    <tr mat-header-row *matHeaderRowDef="[]"></tr>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>{{ 'CONTACT_TABLE.TABLE_HEADERS.NAME' | translate }}</th>
      <td mat-cell *matCellDef="let element" class="narrow-cell">
        <email-user-name-cell [partnerId]="senderId$ | async" [emailAddress]="element.email"></email-user-name-cell>
      </td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'CONTACT_TABLE.TABLE_HEADERS.RECIPIENT_EMAIL' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.email }}</td>
    </ng-container>
    <ng-container matColumnDef="clicks">
      <th mat-header-cell *matHeaderCellDef>{{ 'CONTACT_TABLE.TABLE_HEADERS.CLICKS' | translate }}</th>
      <td mat-cell *matCellDef="let element" class="narrow-cell">{{ element.clicks }}</td>
    </ng-container>
    <ng-container matColumnDef="dateClicked">
      <th mat-header-cell *matHeaderCellDef>{{ 'CONTACT_TABLE.TABLE_HEADERS.DATE_CLICKED' | translate }}</th>
      <td mat-cell *matCellDef="let element" class="narrow-cell">{{ element.dateClicked | glxyDate : dateFormat }}</td>
    </ng-container>

    <tr mat-row *matRowDef="let row; columns: []"></tr>
  </table>
  <glxy-empty-state *ngIf="dataSource.state.totalDataMembers === 0 && !dataSource.state.loading" [size]="'small'">
    <glxy-empty-state-hero>
      <mat-icon>account_circle</mat-icon>
    </glxy-empty-state-hero>
    <p>{{ 'CONTACT_TABLE.EMPTY_STATE.DESCRIPTION' | translate }}</p>
  </glxy-empty-state>
</glxy-table-container>
